import { MenuType } from "@/constants/enums"
import { Challenge } from "@/models/crm/challenge"
import { CascadeOption } from "@/models/core"
import mitt from "mitt"

export const cascadeOptionEventHub = mitt<{
    "cascade-select-item": CascadeOption
}>()

export const challengeEventHub = mitt<{
    "edit-challenge": Challenge
}>()

export const CarpoolPlaceEventHub = mitt<{
    "display-import-modal": boolean
}>()

export const matchEventHub = mitt<{
    "refresh-payment-events": void
}>()

export const appMenuEventHub = mitt<{
    "menu-changed": MenuType
}>()

const eventHub = mitt()
export default eventHub
